export default "__VITE_ASSET__yGbpoGO3__"